import FormLoader from 'components/loader/FormLoader';
import React from 'react';
import {
  CustomInput,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from 'reactstrap';
import IntlMessages from 'helpers/IntlMessages';

const NotificationModal = ({ modalOpen, toggleModal, modalData }) => {
  const flagName = [
    'simple-icon-close',
    'simple-icon-check',
    'simple-icon-exclamation',
  ];
  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      backdrop="static"
      className="notification-modal modal-dialog-centered"
    >
      <ModalBody>
        <div className="d-flex float-right mb-4">
          {' '}
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={toggleModal}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="d-flex mb-4">
          <h2 className="m-auto sim-activation-message text-center">
            {modalData.header}
          </h2>
        </div>

        <div className="text-center mt-2">
          <i className={flagName[modalData.isSuccess]}></i>
        </div>
        

        {modalData?.warningData?.length ? (
          <div className="text-center mt-4 duplicate-pin-details">
            <table className="mx-auto col-md-6">
              <thead>
                <tr>
                  <th> <IntlMessages id="notification.serial-no" /></th>
                  <th><IntlMessages id="notification.pin-no" /></th>
                </tr>
              </thead>
              <tbody>
                {modalData.warningData.map((item) => {
                  return (
                    <tr>
                      <td>{item.serial_no}</td>
                      <td>{item.pin_no}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : null}
      </ModalBody>
      <ModalFooter className="border-0 text-center d-block pt-0">
        <Button outline color="primary btn-lg" onClick={toggleModal}>
          {modalData.isLoading ? <FormLoader /> :  <IntlMessages id="notification.ok" />}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NotificationModal;
